<ng-template>
    <div
    class="menu-panel"
    tabindex="-1"
    role="menu"
    (keydown)="_handleKeydown($event)"
    (click)="emitClosed('click')"
    [ngClass]="_classList"
    [attr.aria-label]="ariaLabel || null"
    [attr.aria-labelledby]="ariaLabelledby || null"
    [attr.aria-describedby]="ariaDescribedby || null"
    [@iccDropdownAnimation]="_panelAnimationState"
    (@iccDropdownAnimation.start)="_onAnimationStart($event)"
    (@iccDropdownAnimation.done)="_onAnimationDone($event)"
    >
        <div class="menu-content" >
            <ng-content></ng-content>
        </div>
    </div>
</ng-template>